import { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

// Tenant settings: branding, report defaults, AI provider.
//
// GET /s1/api/tenant is SELECT *, so any column added to the tenants table appears
// here automatically. PUT is admin-only and its parameter order is positional on the
// server, which is why this sends a whole object rather than a partial patch.
export function useTenant() {
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.get("/s1/api/tenant");
      setTenant(data?.tenant || data);
      setError("");
    } catch (e) {
      setError(e.message || "Could not load tenant settings.");
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = useCallback(async (patch) => {
    setSaving(true); setError(""); setSaved("");
    try {
      // Merge rather than patch: the endpoint COALESCEs against the existing row, and
      // sending a partial object has bitten this codebase before.
      const body = { ...tenant, ...patch, ai_provider: (patch.ai_provider ?? tenant?.ai_provider) || "openai" };
      await api.put("s1/api/tenant/", body);
      setTenant(body);
      setSaved("Settings saved.");
      setTimeout(() => setSaved(""), 3000);
      return true;
    } catch (e) {
      setError(e.message || "Could not save. You may not have permission.");
      return false;
    } finally { setSaving(false); }
  }, [tenant]);

  return { tenant, loading, error, saving, saved, save, reload: load };
}
